import React, { useEffect } from 'react';
import { ISearchDeveloper } from 'store/sagas/apiService/types';
import { ContentWrapper } from 'screens/DevelopersSearchPage/styled';
import Pagination from '../developers-city/Pagination';
import List from '../developers-city/List';
import LoadingSkeleton from '../developers-city/LoadingSkeleton';
import { State } from 'store/state';
import {
  developersSearchDevelopersSelector,
  developersSearchTotalCountSelector,
  isDeveloperSearchLoadingSelector,
} from 'store/state/domainData/selectors';
import { searchDeveloper } from 'store/state/searchDeveloper/actions';
import { connect } from 'react-redux';
import { useLocale } from 'locale';
import { pageSelector } from 'screens/List/selectors';

interface SearchDeveloperPayload {
  page?: number;
}

interface DevelopersCityPageProps {
  totalCount: number;
  developers: ISearchDeveloper[];
  isLoading: boolean;
  page: number;
  searchDevelopers: (data: SearchDeveloperPayload) => void;
}

const DevelopersSearchList: React.FC<DevelopersCityPageProps> = (props) => {
  const { totalCount, developers, isLoading, page, searchDevelopers } = props;
  const { t } = useLocale();

  useEffect(() => {
    searchDevelopers({ page });
  }, [ page, searchDevelopers ]);

  return (
    <ContentWrapper>
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <List items={developers} title={t('developersSearchList.title', { count: totalCount })} isOnIndexPage />
      )}
      <Pagination page={page} totalCount={totalCount} />
    </ContentWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  totalCount: developersSearchTotalCountSelector(state),
  developers: developersSearchDevelopersSelector(state),
  isLoading: isDeveloperSearchLoadingSelector(state),
  page: pageSelector(state),
});

const mapDispatchToProps = {
  searchDevelopers: searchDeveloper,
};

export default connect(mapStateToProps, mapDispatchToProps)(DevelopersSearchList);
